var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoLive2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#F9B8C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5714 25H34.5714C29.8376 25 26 28.8376 26 33.5714V53.5714C26 58.3054 29.8376 62.1429 34.5714 62.1429H54.5714C59.3054 62.1429 63.1429 58.3054 63.1429 53.5714V33.5714C63.1429 28.8376 59.3054 25 54.5714 25Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9046 37.1431L41.476 51.4288L35.7617 47.1431",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoLive2);
export default __webpack_public_path__ + "static/media/go_live_2.3a6ecece7eaaab8dd5765c9f0fe7b0bf.svg";
export { ForwardRef as ReactComponent };